import { render, staticRenderFns } from "./DashboardCardPlans.vue?vue&type=template&id=47d2b232"
import script from "./DashboardCardPlans.vue?vue&type=script&lang=js"
export * from "./DashboardCardPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports